import React, { useRef } from 'react';

import { IconButton } from '@fluentui/react/lib/Button';
import { List } from '@fluentui/react/lib/List';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import {
  Shimmer,
  ShimmerElementType,
  ShimmerElementsGroup
} from '@fluentui/react/lib/Shimmer';

import { InvitesProps } from './Invites.types';

const InvitesComponent = (props: InvitesProps) => {
  const {
    invitations,
    inviteType,
    tooltips,
    requestResendInvite,
    requestDeleteInvite,
  } = props;

  const onSendReminder = (event: React.MouseEvent<HTMLElement>) => {
    requestResendInvite(event.currentTarget.id);
  };

  const onDecline = (event: React.MouseEvent<HTMLElement>) => {
    requestDeleteInvite(event.currentTarget.id);
  };

  const onRenderCell = (item, /*index, isScrolling*/) => {
    return (
      <div className='memberItem' data-is-focusable={true}>
        <div className='memberPersona'>
          <div className='ms-Persona-primaryText'>{item.emailAddress}</div>
          <div className='ms-Persona-secondaryText'>

            {item.isGuest ? 'Guest invited on' : (item.isLAM ? 'External member invited on' : 'FAM invited on')}{' '}
            {item.inviteDate}
          </div>
        </div>
        <div className='memberTools'>
          <TooltipHost content={tooltips.INVITETOOLS_RESEND}>
            <IconButton
              id={item.id}
              iconProps={{ iconName: 'ReplyMirrored' }}
              onClick={onSendReminder}
            />
          </TooltipHost>
          <span className='sep' />
          <TooltipHost content={tooltips.INVITETOOLS_CANCEL}>
            <IconButton
              id={item.id}
              className='memberItem-remove'
              iconProps={{ iconName: 'StatusErrorFull' }}
              onClick={onDecline}
            />
          </TooltipHost>
        </div>
      </div>
    );
  };

  return (
    <Shimmer
      width={'100%'}
      styles={{
        root: {
          marginTop: 20
        }
      }}
      isDataLoaded={invitations !== null}
      customElementsGroup={
        <ShimmerElementsGroup
          flexWrap={true}
          width={`100%`}
          shimmerElements={[
            { type: ShimmerElementType.line, width: '100%', height: 20 },
            { type: ShimmerElementType.gap, width: '100%' },
            { type: ShimmerElementType.line, width: '100%', height: 20 },
            { type: ShimmerElementType.gap, width: '100%' },
            { type: ShimmerElementType.line, width: '100%', height: 20 }
          ]}
        />
      }
    >
      {invitations && invitations.length > 0 ? (
        <List
          items={invitations}
          onRenderCell={onRenderCell}
        />
      ) : (
        <div>There are no {inviteType} invitations. </div>
      )}
    </Shimmer>
  );
}

export default InvitesComponent;